
    import I18n from 'i18nObj';
    
      import 'translations/outcomes.calculation_method_example';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('outcomes.calculation_method_example');
  